import { IHome } from "@src/components/Home";
import React, { useMemo, useState } from "react";
import ClientOnly from "@src/components/ClientOnly";
import Floater from "../Floater";
import Footer from "../Footer";
import Vendors from "../Vendors";
import Parts from "../Parts";
import Backstory from "../Backstory";
import MarqueeComp from "../MarqueeComp";
import Quotes from "../Quotes";
import Masonry from "../Masonry";
import Hero from "../Hero";
// import AsoEbi from "../AsoEbiLink";
import { useHome } from "@src/hooks/useHome";
import Wishlist from "../Wishlist";
import { useQuery } from "@apollo/client";
import {
  Currency,
  GetForeignAccountDetailsQuery,
  GetForeignAccountDetailsQueryVariables,
} from "@src/@types/api.d";
import { GetForeignWalletDetails } from "@src/graphql/queries";
import toast from "react-hot-toast";

const HomeT21: React.FC<IHome> = ({
  slug,
  eventBySlugData,
  eventId,
  eventPartsData,
  backStoryData,
  eventVendorData,
  albumDetailsData,
  heroImageData,
  hasWallet,
  getEventStreamersData,
  liveSchedules,
  eventUuid,
  weddingPartyData,
  inviteResult: initialInviteResult,
}) => {
  const [wishlistOpen, setWishlistOpen] = useState<boolean>(false);

  const { data: foreignWalletDetails, loading: _foreignDetailsLoading } =
    useQuery<
      GetForeignAccountDetailsQuery,
      GetForeignAccountDetailsQueryVariables
    >(GetForeignWalletDetails, {
      skip: !eventId,
      variables: {
        eventId: !!eventId ? eventId : 0,
      },
      fetchPolicy: "network-only",
      onError(error) {
        toast.error(
          <p className="toast">{error?.message ?? "An error occured"}</p>
        );
      },
    });

  const foreignDetails = useMemo(() => {
    // const res = foreignWalletDetails?.getForeignAccountDetails.find(
    //   (item) => item?.currency === Currency.gpb || Currency.usd
    // );
    const res = foreignWalletDetails?.getForeignAccountDetails
      ?.filter((item) => item?.currency !== Currency.Ngn)
      .filter(
        (item): item is NonNullable<typeof item> =>
          item !== null && item !== undefined
      );
    return res;
  }, [foreignWalletDetails]);

  const {
    accessToken,
    inviteResult,
    getAsoebiData,
    isCashGiftSetup,
    isInvitedToEvent,
  } = useHome({
    slug,
    eventBySlugData,
    eventId,
    eventPartsData,
    backStoryData,
    eventVendorData,
    albumDetailsData,
    heroImageData,
    hasWallet,
    getEventStreamersData,
    liveSchedules,
    eventUuid,
    weddingPartyData,
    inviteResult: initialInviteResult,
  });
  return (
    <>
      <ClientOnly>
        <Floater
          accessToken={accessToken}
          eventId={eventId}
          eventUuid={eventUuid}
          slugData={eventBySlugData}
          hasWallet={hasWallet}
          getEventStreamersData={getEventStreamersData}
          liveSchedules={liveSchedules}
          access_control={
            eventBySlugData?.eventBySlug?.event_preference?.access_control ??
            false
          }
          qr_code={inviteResult?.signupByInviteLink?.invitation?.qr_code ?? ""}
          getAsoebiData={getAsoebiData}
          admits={inviteResult?.signupByInviteLink?.invitation?.admits ?? 1}
          invitation={inviteResult?.signupByInviteLink?.invitation}
          isInvitedToEvent={isInvitedToEvent}
        />

        <Hero
          heroImageData={heroImageData}
          albumDetailsData={albumDetailsData}
          eventId={eventId}
          slugData={eventBySlugData}
        />

        <MarqueeComp eventId={eventId} slugData={eventBySlugData} />

        <Wishlist
          albumDetailsData={albumDetailsData}
          eventId={eventId}
          eventUuid={eventUuid}
          setOpen={setWishlistOpen}
          availableGiftPaymentCurrencies={
            eventBySlugData?.eventBySlug?.available_gift_payment_currencies ??
            []
          }
          foreignDetails={foreignDetails}
        />

        <Masonry
          eventSlug={slug}
          eventId={eventId}
          albumDetailsData={albumDetailsData}
        />

        {/* <Parts
          liveSchedules={liveSchedules}
          eventId={eventId}
          eventPartsData={eventPartsData}
        /> */}

        {/* <Quotes albumDetailsData={albumDetailsData} /> */}

        {/* <Backstory eventId={eventId} backStoryData={backStoryData} /> */}

        {/* <Vendors eventId={eventId} eventVendorData={eventVendorData} /> */}

        <Footer slug={eventBySlugData} />
      </ClientOnly>
    </>
  );
};

export default HomeT21;
